import type { OfferType, TierRule } from '@/types/BrandOffer.types';
import { OFFER_TYPE_SPEC } from './OfferProductPreview.constants';

export function needsCouponDiscount(t: OfferType): boolean {
  return (
    OFFER_TYPE_SPEC[t].productPreview.priceCalculation === 'FLAT_OR_PERCENT'
  );
}

export function needsTextDiscount(t: OfferType): boolean {
  return OFFER_TYPE_SPEC[t].productPreview.displayText === 'ADMIN_TEXT';
}

export function needsTierRules(t: OfferType): boolean {
  return OFFER_TYPE_SPEC[t].productPreview.priceCalculation === 'TIER_DYNAMIC';
}

export function needsOfferCopyLine(t: OfferType): boolean {
  return OFFER_TYPE_SPEC[t].productPreview.priceSuffix === 'ADMIN_TEXT';
}

/** Tier values default to rupees-off when the offer type prefers units (legacy tiered coupons). */
export function tierUsesUnitValue(t: OfferType): boolean {
  return OFFER_TYPE_SPEC[t].form.usesUnitValueInsteadOfPercentage;
}

/** How to interpret a tier rule's numeric `value`. */
export function effectiveTierValueType(
  rule: TierRule,
  offerType: OfferType
): 'FLAT' | 'PERCENT' {
  if (rule.tierValueType === 'FLAT' || rule.tierValueType === 'PERCENT') {
    return rule.tierValueType;
  }
  return tierUsesUnitValue(offerType) ? 'FLAT' : 'PERCENT';
}
